// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { baseUrl } from '../../../../app.config'

// ** Axios Imports
import axios from 'axios'
import toast from 'react-hot-toast'

export const getBannerList = createAsyncThunk(
    'businessBanner/getBannerList',
    async (params) => {
        console.log("getBannerList", params)

        const response = await axios.get(baseUrl() + '/banner', { params })

        return {
            totalPages: response.data.result.count.total,
            params: response.data.params,
            data: response.data.result.data
        }
    }
)

export const allBusinessList = createAsyncThunk(
    'businessBanner/allBusinessList',
    async (params) => {
        const response = await axios.get(baseUrl() + '/banner', { params })
        return {
            params: response.data.params,
            allBusinessList: response.data.result
        }
    }
)

export const addBanner = createAsyncThunk(
    'businessBanner/addBanner',
    async ({ payload, params }, { dispatch, getState }) => {
        console.log("addBanner", params)

        try {
            await axios.post(baseUrl() + '/banner/add', payload)
            toast.success('Banner Added successfully')
            await dispatch(getBannerList(params))
            return true
        } catch (error) {
            toast.error(error?.response?.data?.message)
            return false
        }
    }
)

export const updateBanner = createAsyncThunk(
    'businessBanner/updateBanner',
    async ({ id, payload, params }, { dispatch, getState }) => {
        console.log("updateBanner", params)

        try {
            await axios.put(baseUrl() + `/banner/update/${id}`, payload)
            toast.success('Banner Updated successfully')
            await dispatch(getBannerList(params))
            return true
        } catch (error) {
            toast.error(error?.response?.data?.message)
            return false
        }
    }
)

export const deleteBanner = createAsyncThunk(
    'businessBanner/deleteBanner',
    async ({ id, params }, { dispatch, getState }) => {
        try {
            await axios.delete(baseUrl() + `/banner/${id}`),
                toast.success('Banner Deleted successfully')
            await dispatch(getBannerList(params))
            return true
        } catch (error) {
            toast.error(error?.response?.data?.message)
            return false
        }
    }
)

export const businessBanner = createSlice({
    name: 'businessBanner',
    initialState: {
        bannerList: [],
        selectFacility: [],
        allBusinessList: [],
        reload: false,
        loader: false,
        rowsPerPage: 10,
        currentPage: 1,
        totalPages: 0,
        selected: null,
        clearFilter: false,
        status: '0',
        loading: false,
        params: {
            pageNo: 1,
            pageSize: 10
        },
        rowType: 'row1'


    },
    reducers: {
        selectBusinessBanner: (state, action) => {
            if (action.payload === null) {
                state.selected = null
            } else {
                state.selected = action.payload
            }
        },
        selectCurrentPage: (state, action) => {
            if (action.payload === null) {
                state.currentPage = null
            } else {
                state.currentPage = action.payload
            }
        },
        selectRowsPerPage: (state, action) => {
            if (action.payload === null) {
                state.rowsPerPage = null
            } else {
                state.rowsPerPage = action.payload
            }
        },
        selectClearFilter: (state, action) => {
            state.clearFilter = action.payload
        },
        setStatus: (state, action) => {
            state.status = action.payload
        },
        setLoader: (state) => {
            state.loader = !state.loader
        },
        setLoading: (state, action) => {
            state.loading = action.payload
        },
        setRowType: (state, action) => {
            state.rowType = action.payload
        }
    },

    extraReducers: {
        [addBanner.fulfilled]: (state, action) => {
            state.reload = !state.reload
        },
        [getBannerList.fulfilled]: (state, action) => {
            state.bannerList = action.payload.data
            state.totalPages = action.payload.totalPages
            state.loader = false
        },
        [allBusinessList.fulfilled]: (state, action) => {
            state.allBusinessList = action.payload.allBusinessList
        },
        [updateBanner.fulfilled]: (state, action) => {
            state.reload = !state.reload
            state.loader = false
        },
    }
})

export const { selectBusinessBanner, selectRowsPerPage, selectCurrentPage, setStatus, setLoader,
    setLoading, selectClearFilter, setRowType } = businessBanner.actions

export default businessBanner.reducer
